import axios from '@/utils/request.js'

// 流水统计
export function getrunwaterList(params) {
  return axios.get('/board/getrunwaterList', {
    params
  })
}
export function getFlowimgWater(params) {
  return axios.get('/board/getFlowimgWater', {
    params
  })
}
export function getadverplate(params) {
  return axios.get('/board/adverplate', {
    params
  })
}
export function getDealerList(params) {
  return axios.get('/board/getDealerList', {
    params
  })
}
export function getDealerGuiData(params) {
  return axios.get('/board/getFanMoneyList', {
    params
  })
}
export function getCopyRightList(params) {
  return axios.get('/board/getCopyRightList', {
    params
  })
}
export function getrwList(params) {
  return axios.get('/board/arwList', {
    params
  })
}
export function getmanzhanList(params) {
  return axios.get('/board/manzhan', {
    params
  })
}
export function getpayMoneyList() {
  return axios.get('/board/payMoneyList')
}
//获取漫展详细数据
export function getExhibitionInfo() {
  return axios.post('/board/getExhibitionInfos',{
    params
  })
}
export function getmanzhanprice(params) {
  return axios.get('/board/getExhibitionInfos', {
    params
  })
}
// 收入统计
export function getComeList(params) {
  return axios.get('/board/incomelist', {
    params
  })
}
// 支出统计
export function getpayList(params) {
  return axios.get('/board/paylist', {
    params
  })
}
// 提现统计
export function getrechargeList(params) {
  return axios.get('/board/rechargeall', {
    params
  })
}
export function getericarechargeList(params) {
  return axios.get('/financial/recharge', {
    params
  })
}
export function rechargeinfo(params) {
  return axios.get('/financial/rechargeinfo', {
    params
  })
}
export function getericaall(params) {
  return axios.get('/financial/reAndex', {
    params
  })
}
export function getallusertel(params) {
  return axios.get('/financial/getallusertel', {
    params
  })
}
export function getrechargeallList(params) {
  return axios.get('/board/rechargealllist', {
    params
  })
}
// 提现统计---个人信息
export function getrechargeuserList(params) {
  return axios.get('/board/rechargeuserinfo', {
    params
  })
}